import { memo, useCallback } from 'react'

import * as Styled from './styled'
import VoiceToneTags from './Tags'

import { VoiceToneInstruction } from './Instructions'
import { ITtsSpeakerTone } from 'types/text-to-speech'
import { ttsSelectors } from 'store/features/tts/selectors'
import { useSelector } from 'react-redux'

const VoiceToneContainer: React.FC<{
  toneInstruction?: string
  setToneInstruction: (instruction: string) => void
}> = ({ toneInstruction, setToneInstruction }) => {
  const speakerTones = useSelector(ttsSelectors.speakerTones)

  const handleToneTextChange = useCallback(
    (text: string) => {
      setToneInstruction(text)
    },
    [setToneInstruction]
  )

  const handleToneChange = useCallback(
    (tone: ITtsSpeakerTone) => {
      const { instructions } = tone
      setToneInstruction(instructions)
    },
    [setToneInstruction]
  )

  if (!speakerTones) return null
  return (
    <Styled.SpeakerToneContainer>
      <VoiceToneTags onToneChange={handleToneChange} toneTags={speakerTones} />
      <VoiceToneInstruction
        toneInstruction={toneInstruction}
        handleToneTextChange={handleToneTextChange}
      />
    </Styled.SpeakerToneContainer>
  )
}

export default memo(VoiceToneContainer)
